
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [{"display":"inline-block","vertical-align":"middle","overflow":"visible"},style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16","width":"16","height":"16","fill":"none","stroke":"#2c3e50","stroke-width":"3","style":"display:inline-block;vertical-align:middle;overflow:visible;"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.0606601717798212 1.0606601717798212 L14.939339828220179 14.939339828220179"}}),_c('path',{attrs:{"d":"M14.939339828220179 1.0606601717798212 L1.0606601717798212 14.939339828220179"}})])
          )
        }
      }
    